import { Shield, Clock, MapPin, Bolt } from './Icons';

export default function About({ company }) {
  const c = company.contact || {};
  return (
    <section className="section section--about" id="about">
      <div className="container about__grid">
        <div className="about__copy">
          <span className="eyebrow">About us</span>
          <h2 className="section__title">Built in Kenya, engineered to last</h2>
          <p className="about__lead">{company.about}</p>
          {company.director && (
            <p className="about__director">
              Led by <strong>{company.director}</strong>, Thunder Technologies pairs hands-on
              installation expertise with a growing platform of digital tools.
            </p>
          )}
          <div className="about__badges">
            {company.warranty && (
              <div className="about__badge">
                <Shield width={20} height={20} />
                <span>{company.warranty}</span>
              </div>
            )}
            {company.hours && (
              <div className="about__badge">
                <Clock width={20} height={20} />
                <span>{company.hours}</span>
              </div>
            )}
            {c.country && (
              <div className="about__badge">
                <MapPin width={20} height={20} />
                <span>Serving businesses across {c.country}</span>
              </div>
            )}
          </div>
        </div>

        <aside className="about__stats">
          <div className="about__stat">
            <Bolt width={22} height={22} />
            <strong>100%</strong>
            <span>Business-focused installs</span>
          </div>
          <div className="about__stat">
            <strong>2-yr</strong>
            <span>Hardware warranty</span>
          </div>
          <div className="about__stat">
            <strong>24/7</strong>
            <span>Secure remote access</span>
          </div>
          <div className="about__stat">
            <strong>Growing</strong>
            <span>Digital-tools ecosystem</span>
          </div>
        </aside>
      </div>
    </section>
  );
}
